import PropTypes from "prop-types";
import Lottie from "lottie-react";
import classNames from "classnames";
import loadingAnimationData from "../../../assets/lotties/loading.json";
import classes from "./Loading.module.css";

const Loading = (props) => {
  const { className } = props;

  return (
    <Lottie
      animationData={loadingAnimationData}
      className={classNames(classes["loading"], className)}
    />
  );
};

export default Loading;

Loading.propTypes = {
  className: PropTypes.string,
};
